export function getDateObject(date) {
    const monthFormatter = new Intl.DateTimeFormat('es-ES', {month: 'long'});
    const localDate = createLocalDate(date);
    const fullMonth = capitalizeFirstLetter(
        monthFormatter.format(localDate),
    );
    const month = fullMonth.substring(0, 3);
    const day = localDate.getDate().toString().padStart(2, '0');
    const year = localDate.getFullYear().toString();
    const dayName = getDayOfWeek(localDate);
    return { dayName: dayName, day: day,month: month, fullMonth: fullMonth, year: year };
}

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export function createLocalDate(date) {
    return new Date(Date.parse(date.replace(/-/g, '/')));
}

let days = ['Domingo','Lunes','Martes','Miércoles',
    'Jueves','Viernes','Sábado'];
//Entrada: 'yyyy-mm-dd'
let getDayOfWeek = (date) =>  {return days[date.getDay()];}


//Entrada: date:'yyyy-mm-dd', firstDate:'yyyy-mm-dd', lastDate:'yyyy-mm-dd',
//Salida: boolean
export function dateBetween(date, firstDate,lastDate){

    let firstDateFlag = firstDate.replace(/-/g, '');
    let lastDateFlag = lastDate.replace(/-/g, '');
    let dateFlag = date.replace(/-/g, '')

    return firstDateFlag<dateFlag && lastDateFlag > dateFlag;
}